import Cookies from 'js-cookie';

const primaryCalculationType = Cookies.get('primaryCalculationType');

const caratToGm = (value) => {
  return value * 0.2;
};
const caratToLal = (value) => {
  return value * 1.71468;
};
const lalToGm = (value) => {
  return value * 0.11664;
};
const GmToLal = (value) => {
  return value / 0.11664;
};

const receivedDataToStructuredFormat = (receivedData) => {
  return receivedData
    ?.filter((item) => item?.itemCode !== undefined) // Keep only items with a valid itemName
    .map((item) => {
      return {
        ItemName: item?.itemName || '',
        code: item?.itemCode || '',
        gwt: item?.grossWeight?.toString() || '',
        netWt: item?.netWeight?.toString() || '',
        diamond:
          item.diamondData?.map((d) => ({
            name: d?.itemName || '',
            piece: d?.pcs || '',
            wt: d?.weight?.toString() || '',
            rate: d?.rate?.toString() || '',
            amount: d?.amount?.toString() || '',
            unit: d?.unit || '',
          })) || [],
        stone:
          item.stoneData?.map((s) => ({
            name: s?.itemName || '',
            piece: s?.pcs || '',
            wt: s?.weight?.toString() || '',
            rate: s?.rate?.toString() || '',
            amount: s?.amount?.toString() || '',
            unit: s?.unit || '',
          })) || [],
        luxuryTaxAmount: item?.luxuryTaxAmount || 0,
        vatAmount: item?.vatAmount || 0,
        makingCharge: item?.makingAmount?.toString() || '',
        // totalAmount: item?.netAmount?.toString() || '',
        extra: item.extraAmount?.toString() || '',
        // metalAmount: '',
        netAmount: item?.netAmount || '',
        subTotal: item?.subTotal || '',
        netWithWastage: item?.netWithWastage || '',
        wastageWeight: item?.wastageWeight || '',
        purity: Number(item?.purity),
        rate: Number(item?.rate),
      };
    });
};

const generateTableBody = (
  data,
  isDiamond,
  isStone,
  isLuxuryTax,
  isVAT,
  isNamaste,
) => {
  const primaryCalculationType = Cookies.get('primaryCalculationType');
  return data?.map((item, index) => {
    const row = isNamaste
      ? [
          `${index + 1}`,
          item?.ItemName,
          item?.code,
          // item?.gwt,
          // Number(
          //   (
          //     item?.gwt / (primaryCalculationType === 'lal' ? 100 : 11.664)
          //   ).toFixed(3),
          // ),
          // parseInt((item?.purity * item?.rate ) / 24),
          parseInt(
            (item?.purity *
              item?.rate *
              (primaryCalculationType === 'lal' ? 100 : 11.664)) /
              100,
          ).toLocaleString(isNamaste ? 'en-US' : 'en-In'),
        ]
      : [
          `${index + 1}`,
          item?.ItemName,
          item?.code,
          // item?.gwt,
          Number(
            (
              item?.gwt / (primaryCalculationType === 'lal' ? 100 : 11.664)
            ).toFixed(3),
          ),
          // parseInt((item?.purity * item?.rate ) / 24),
          parseInt(
            (item?.purity *
              item?.rate *
              (primaryCalculationType === 'lal' ? 100 : 11.664)) /
              100,
          ).toLocaleString(isNamaste ? 'en-US' : 'en-In'),
        ];
    if (isDiamond && item?.diamond) {
      row.push(
        item.diamond.map((d) => d.name).join('\n\n'),
        item.diamond.map((d) => d.rate).join('\n\n'),
        item.diamond.map((d) => d.piece).join('\n\n'),
        item.diamond.map((d) => d.wt).join('\n\n'),
        item.diamond.map((d) => d.amount).join('\n\n'),
      );
    }

    if (isStone && item?.stone) {
      row.push(
        item.stone.map((s) => s?.name).join('\n\n'),
        item.stone.map((s) => s?.rate).join('\n\n'),
        item.stone.map((s) => s?.piece).join('\n\n'),
        item.stone.map((s) => `${s?.wt} ${s?.unit}`).join('\n\n'),
        item.stone.map((s) => s?.amount).join('\n\n'),
      );
    }
    if (isLuxuryTax) {
      row.push(Number(item?.luxuryTaxAmount).toFixed(3));
    }
    if (isVAT) {
      row.push(Number(item?.vatAmount).toFixed(3));
    }
    row.push(
      Number(
        (item?.netWt?.split(' ')[0] || item?.netWt) /
          (primaryCalculationType === 'lal' ? 100 : 11.664),
      ).toFixed(3), // Net Wt
      (
        item?.wastageWeight / (primaryCalculationType === 'lal' ? 100 : 11.664)
      ).toFixed(3),
      Number(
        String(item?.netWithWastage)?.split(' ')[0] /
          (primaryCalculationType === 'lal' ? 100 : 11.664),
      ).toFixed(3),
      item?.makingCharge, // Making Charge
      item?.extra, // Extra
      // Number((item?.netAmount || 0).toFixed(3)).toLocaleString(
      Number((item?.subTotal || 0).toFixed(3)).toLocaleString(
        isNamaste ? 'en-US' : 'en-In',
      ), // Net Amount
    );

    return row;
  });
};

export const tableBodyGenerator = (
  filteredTableData,
  isDiamond,
  isStone,
  isLuxuryTax,
  isVAT,
  primaryCalculationType,
  isNamaste,
) => {
  const structuredData = receivedDataToStructuredFormat(filteredTableData);
  const tableBodyData = generateTableBody(
    structuredData,
    isDiamond,
    isStone,
    isLuxuryTax,
    isVAT,
    isNamaste,
  );
  return tableBodyData;
};

export const tableHeadersGenerator = (
  isDiamond,
  isStone,
  isLuxuryTax,
  isVAT,
  primaryCalculationType,
  isNamaste,
) => {
  const row = isNamaste
    ? [
        [
          { content: 'S.No', rowSpan: 2 },
          { content: 'Item Name', rowSpan: 2 },
          { content: 'Code', rowSpan: 2 },
          // { content: `Gross.wt.\n( ${primaryCalculationType} )`, rowSpan: 2 },
          // { content: `Rate per\n( ${primaryCalculationType} )`, rowSpan: 2 },
          // { content: `Gross.wt.\n( tola )`, rowSpan: 2 },
          { content: `Rate per\n( tola )`, rowSpan: 2 },
        ],
        [],
      ]
    : [
        [
          { content: 'S.No', rowSpan: 2 },
          { content: 'Item Name', rowSpan: 2 },
          { content: 'Code', rowSpan: 2 },
          // { content: `Gross.wt.\n( ${primaryCalculationType} )`, rowSpan: 2 },
          // { content: `Rate per\n( ${primaryCalculationType} )`, rowSpan: 2 },
          { content: `Gross.wt.\n( tola )`, rowSpan: 2 },
          { content: `Rate per\n( tola )`, rowSpan: 2 },
        ],
        [],
      ];

  if (isDiamond) {
    row[0].push({ content: 'Diamond Details', colSpan: 5 });
    row[1].push(
      { content: 'Name' },
      { content: 'Rate' },
      { content: 'Pcs' },
      { content: `wt.\n( Crt )` },
      { content: 'Amt.' },
    );
  }
  if (isStone) {
    row[0].push({ content: 'Stone', colSpan: 5 });
    row[1].push(
      { content: 'Name' },
      { content: 'Rate' },
      { content: 'Pcs' },
      { content: `Wt.\n( ${primaryCalculationType} )` },
      { content: 'Amt.' },
    );
  }
  if (isLuxuryTax) {
    row[0].push({ content: 'Luxury Tax', rowSpan: 2 });
  }
  if (isVAT) {
    row[0].push({ content: 'VAT', rowSpan: 2 });
  }

  row[0].push(
    // { content: `Net.wt.\n(${primaryCalculationType})`, rowSpan: 2 },
    // { content: `Wastage.wt.\n(${primaryCalculationType})`, rowSpan: 2 },
    // { content: `Net With Wastage\n(${primaryCalculationType})`, rowSpan: 2 },
    { content: `Net.wt.\n(tola)`, rowSpan: 2 },
    { content: `Wastage.wt.\n(tola)`, rowSpan: 2 },
    { content: `Net With Wastage\n(tola)`, rowSpan: 2 },
    { content: 'Making Charge', rowSpan: 2 },
    { content: 'Extra Amt.', rowSpan: 2 },
    //   { content: 'Metal Amt.', rowSpan: 2 },
    // { content: 'Net Amt.', rowSpan: 2 },
    { content: 'Sub Total', rowSpan: 2 },
  );
  return row;
};

const diamondTotalCalulation = (details, colName) => {
  return (
    details
      ?.map((item) =>
        item?.diamondData?.reduce(
          (acc, item) => Number(item?.[colName]) + acc,
          0,
        ),
      )
      .filter((item) => item !== undefined)
      .reduce((acc, item) => acc + item, 0) || ''
  );
};
const StoneTotalCalulation = (details, colName) => {
  return (
    details
      ?.map((item) =>
        item?.stoneData?.reduce(
          (acc, item) => Number(item?.[colName]) + acc,
          0,
        ),
      )
      .filter((item) => item !== undefined)
      .reduce((acc, item) => acc + item, 0) || ''
  );
};
const StoneWeightTotalCalulation = (
  details,
  colName,
  primaryCalculationType,
) => {
  return (
    details
      ?.map((item) =>
        item?.stoneData?.reduce((acc, item) => {
          if (primaryCalculationType === item?.unit) {
            return Number(item?.[colName]) + acc;
          }

          if (primaryCalculationType === 'gm') {
            if (item.unit === 'crt') {
              return caratToGm(Number(item?.[colName])) + acc;
            }
            if (item.unit === 'lal') {
              return lalToGm(Number(item?.[colName])) + acc;
            }
          }
          if (primaryCalculationType === 'lal') {
            if (item.unit === 'crt') {
              return caratToLal(Number(item?.[colName])) + acc;
            }
            if (item.unit === 'gm') {
              return GmToLal(Number(item?.[colName])) + acc;
            }
          }
        }, 0),
      )
      .filter((item) => item !== undefined)
      .reduce((acc, item) => acc + item, 0)
      .toFixed(primaryCalculationType === 'gm' ? 3 : 1) || ''
  );
};

export const tableFooterGenerator = (
  total,
  details,
  isDiamond,
  isStone,
  isLuxuryTax,
  isVAT,
  primaryCalculationType,
  isNamaste,
) => {
  const drate = '';
  const dpiece = diamondTotalCalulation(details, 'pcs') || '';
  const dwt = diamondTotalCalulation(details, 'weight') || '';
  const damt = diamondTotalCalulation(details, 'amount') || '';
  const srate = '';
  const spiece = StoneTotalCalulation(details, 'pcs') || '';
  const swt =
    StoneWeightTotalCalulation(details, 'weight', primaryCalculationType) || '';
  const samt = StoneTotalCalulation(details, 'amount') || '';
  const extra =
    details?.reduce((acc, item) => Number(item?.extraAmount) + acc, 0) || '';
  const netwt =
    details?.reduce(
      // (acc, item) => Number(item?.netWeight.split(' ')[0]) + acc,
      (acc, item) =>
        Number(String(item?.netWeight).split(' ')[0]) /
          (primaryCalculationType === 'lal' ? 100 : 11.664) +
        acc,
      0,
    ) || '';
  const netWithWastage =
    details?.reduce(
      // (acc, item) => Number(item?.netWithWastage.split(' ')[0]) + acc,
      (acc, item) =>
        Number(String(item?.netWithWastage).split(' ')[0]) /
          (primaryCalculationType === 'lal' ? 100 : 11.664) +
        acc,
      0,
    ) || '';
  const wastageWt =
    // details?.reduce((acc, item) => Number(item?.wastageWeight) + acc, 0) || '';
    details?.reduce(
      (acc, item) =>
        Number(item?.wastageWeight) /
          (primaryCalculationType === 'lal' ? 100 : 11.664) +
        acc,
      0,
    ) || '';
  const makingCharge =
    details?.reduce((acc, item) => Number(item?.makingAmount) + acc, 0) || '';
  const netAmt =
    Number(
      details
        // ?.reduce((acc, item) => Number(item?.netAmount) + acc, 0)
        ?.reduce((acc, item) => Number(item?.subTotal) + acc, 0)
        .toFixed(3),
    ).toLocaleString(isNamaste ? 'en-US' : 'en-In') || '';
  const gwt =
    // details?.reduce((acc, item) => Number(item?.grossWeight) + acc, 0) || '';
    details
      ?.reduce(
        (acc, item) =>
          Number(item?.grossWeight) /
            (primaryCalculationType === 'lal' ? 100 : 11.664) +
          acc,
        0,
      )
      .toFixed(3) || '';

  const row = isNamaste
    ? [[' ', 'Total', '', `  `]]
    : [[' ', 'Total', '', ` ${gwt} `, `  `]];
  if (isDiamond) {
    row[0].push('  ', ` ${drate} `, ` ${dpiece} `, ` ${dwt} `, ` ${damt} `);
  }

  if (isStone) {
    row[0].push('  ', ` ${srate} `, ` ${spiece} `, ` ${swt} `, ` ${samt} `);
  }
  if (isLuxuryTax) {
    row[0].push('  ');
  }
  if (isVAT) {
    row[0].push('  ');
  }
  row[0].push(
    ` ${netwt.toFixed(3)} `,
    `${wastageWt ? wastageWt.toFixed(3) : ''}`,
    `${netWithWastage ? netWithWastage.toFixed(3) : ''}`,
    ` ${makingCharge} `,
    ` ${extra} `,
    ` ${netAmt} `,
  );
  return row;
};
